import type { LeadershipTier } from '@/types/user';

export const LEADERSHIP_TIER = {
  NONE: 'NONE',
  TOP_LEADER: 'TOP_LEADER',
  LEADERSHIP_MEMBER: 'LEADERSHIP_MEMBER',
  DEPARTMENT_LEADER: 'DEPARTMENT_LEADER',
} as const satisfies Record<string, LeadershipTier>;

export const LEADERSHIP_TIER_LABELS: Record<LeadershipTier, string> = {
  NONE: '无',
  TOP_LEADER: '最高领导',
  LEADERSHIP_MEMBER: '领导班子成员',
  DEPARTMENT_LEADER: '单位负责人',
};

export const LEADERSHIP_TIER_OPTIONS = Object.entries(LEADERSHIP_TIER_LABELS).map(
  ([value, label]) => ({
    value: value as LeadershipTier,
    label,
  }),
);

export function formatLeadershipTier(tier: LeadershipTier): string {
  return LEADERSHIP_TIER_LABELS[tier] ?? tier;
}

/** 最高领导与班子成员：仅监管查看，不提交个人日报 */
export function isLeadershipViewerTier(tier?: LeadershipTier | null): boolean {
  return tier === LEADERSHIP_TIER.TOP_LEADER || tier === LEADERSHIP_TIER.LEADERSHIP_MEMBER;
}
